import React from "react"
import { Flex, Box } from "@rebass/grid/emotion"

import { TextElementNova } from "@nutrafol/nutrafol-ui-kit/dist/TextElementNova"
import { ButtonNova } from "@nutrafol/nutrafol-ui-kit/dist/ButtonNova"
import { RootCauseItem } from "./rootcauses.styled"

import Section from "../section/section"

const RootCauses = ({ data }) => {
  const { title, titleWidth = [325, 325, 555, 750], causes, cta } = data
  return (
    <Section className="root-causes">
      <Box mb={[32, 32, 40, 80]} px={[0]} mx="auto" maxWidth={titleWidth}>
        <TextElementNova
          element="h2"
          text={title}
          className="Title-20-Super-Normal text-center"
        />
      </Box>
      <Flex
        flexWrap="wrap"
        className="border border-nova-transparency-black-20 rounded"
      >
        {causes.map((cause, i) => {
          return (
            <RootCauseItem
              flexDirection="column"
              width={[1 / 2, 1 / 2, 1 / 2, 1 / 3]}
              p={[16, 16, 24, 32]}
              key={i}
              className={`mobileOrder-${cause.mobileOrder} desktopOrder-${cause.desktopOrder}`}
            >
              <TextElementNova
                element={`h3`}
                className="Body-30-Dia-Strong mb-10 sm:mb-20 md:mb-[65px]"
                text={cause.name}
              />
              <TextElementNova
                className="Body-20-Dia-Normal"
                text={cause.description}
              />
            </RootCauseItem>
          )
        })}
      </Flex>
      <Box mt={[32, 32, 40, 80]} className="w-fit mx-auto">
        <ButtonNova
          ctaLink={cta.destination}
          label={cta.label}
          icon={`Right`}
          className={`root-causes-cta mx-auto`}
          trackObject={{
            destination: "/quiz/",
            type: "link",
            text: cta.label,
          }}
        />
      </Box>
    </Section>
  )
}

export default RootCauses
